export default {"src":"/_next/static/media/directions.381b3967.svg","height":24,"width":24};